import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementCbIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path d="M24 3.15927H0V20.8407H24V3.15927Z" fill="url(#paint0_linear_7286_166577)" />
			<path
				d="M7.63574 8C9.0233 8.00006 10.5731 8.28128 11.458 9.03906C12.2025 9.67554 12.4462 10.6655 12.4893 11.626H7.62598L7.62305 11.958H12.4971C12.497 13.0541 12.1936 14.2599 11.3135 14.9775C10.4334 15.6951 8.97929 15.9218 7.63574 15.9219C6.25283 15.9219 4.81858 15.7218 3.93359 14.9658C3.10155 14.2548 2.77645 13.0225 2.77637 11.9619C2.77637 10.9499 2.94452 9.82261 3.70898 9.12207C4.59875 8.30876 6.19358 8 7.63574 8ZM19.582 11.9502C20.5719 12.0001 21.3594 12.8677 21.3594 13.8691C21.3609 14.3501 21.1768 14.8132 20.8457 15.1621C20.5145 15.5109 20.0614 15.7187 19.5811 15.7422V15.7471H12.8154V11.958L19.582 11.9502ZM19.3965 8.15234C19.4333 8.15461 19.4705 8.15819 19.5039 8.1582C19.7316 8.15681 19.9574 8.20063 20.168 8.28711C20.3786 8.3736 20.5704 8.50111 20.7314 8.66211C20.8923 8.82303 21.02 9.01416 21.1064 9.22461C21.1929 9.43519 21.2367 9.66104 21.2354 9.88867C21.235 10.3257 21.0702 10.7467 20.7744 11.0684C20.4785 11.3901 20.0723 11.5891 19.6367 11.626H12.8154V8.15234H19.3965Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_7286_166577"
					x1="11.9714"
					y1="3.15826"
					x2="11.9714"
					y2="20.8518"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#1A2045" />
					<stop offset="0.35" stopColor="#1A2045" />
					<stop offset="0.47" stopColor="#2D4B81" />
					<stop offset="0.55" stopColor="#3866A6" />
					<stop offset="0.61" stopColor="#3766A2" />
					<stop offset="0.66" stopColor="#356597" />
					<stop offset="0.72" stopColor="#326584" />
					<stop offset="0.77" stopColor="#2D6369" />
					<stop offset="0.82" stopColor="#276246" />
					<stop offset="0.85" stopColor="#236132" />
					<stop offset="1" stopColor="#236132" />
				</linearGradient>
			</defs>
		</svg>
	);
}

PaiementCbIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementCbIcon;
